import * as React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { IExtraction, IExtractionBatch } from '../../types/my-types';
import { getIdFromUrl } from '../../utils/getIdFromUrl';
import useGlynt from './useGlynt';
import { AppContext } from '../../App';

export default function useGetDocIdsByEB(
  extractionBatchId: string,
  modelOpen: boolean,
  groupKey?: string
) {
  const { setToast } = React.useContext(AppContext);
  const [docIds, setDocIds] = React.useState<string[]>([]);

  const glynt = useGlynt();
  const client = useQueryClient();

  React.useEffect(() => {
    if (modelOpen) {
      client
        .fetchQuery({
          queryKey: ['extractionBatch', extractionBatchId],
          queryFn: async () => await (await glynt).extractionBatch.retrieve(extractionBatchId),
        })
        .then((ebData: IExtractionBatch) => {
          let documents: string[] = [];
          if (groupKey) {
            // TODO: get full extraction batch, extraction batch list do not have extractions_by_training_set
            let groupExtractions: IExtraction[] = [];
            let gk = groupKey === 'Unclassified' ? 'None' : groupKey;
            let extractionIds = ebData
              ? ebData.extractions_by_training_set[gk].map((extractionUrl) =>
                  getIdFromUrl(extractionUrl)
                )
              : [];
            // fetch group extractions -> document ids
            // console.log({ extractionIds });
            if (extractionIds.length > 0) {
              // TODO: not efficient, if api can give the doc ids of extraction would help
              Promise.all(
                extractionIds.map(async (extractionId: string, index: number) => {
                  try {
                    let data = await client.fetchQuery({
                      queryKey: ['extraction.final', extractionId],
                      queryFn: async () => await (await glynt).extraction.retrieve(extractionId),
                    });
                    groupExtractions[index] = data;
                  } catch (error) {
                    console.error(error);
                    // groupExtractions[index] = null;
                  }
                })
              )
                .then(() => {
                  documents = groupExtractions.map((extraction) =>
                    getIdFromUrl(extraction.document)
                  );
                  // console.log({ documents });
                  setDocIds(documents);
                })
                .catch(console.error);
            }
          } else {
            documents = ebData ? ebData.documents.map((doc) => getIdFromUrl(doc)) : [];
            setDocIds(documents);
          }
        })
        .catch(() => {
          setToast({
            variant: 'error',
            open: true,
            message: 'Unable to get documents.',
          });
        });
    }

    // eslint-disable-next-line
  }, [extractionBatchId, groupKey, modelOpen]);

  return docIds;
}
